import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { lookupInvitationForRegistration } from '../../services/auth/invitationService';

interface InviteAuthRedirectProps {
  returnTo: string;
  invitationToken: string;
}

function buildLoginUrl(returnTo: string): string {
  return returnTo && returnTo !== '/login'
    ? `/login?returnTo=${encodeURIComponent(returnTo)}`
    : '/login';
}

const InviteAuthRedirect: React.FC<InviteAuthRedirectProps> = ({ returnTo, invitationToken }) => {
  const [redirectTo, setRedirectTo] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const loginUrl = buildLoginUrl(returnTo);
    const registerUrl = `/register?returnTo=${encodeURIComponent(returnTo)}`;

    const resolveRedirect = async () => {
      try {
        const result = await lookupInvitationForRegistration(invitationToken);
        if (cancelled) {
          return;
        }

        if (result.valid && result.hasExistingAccount === false) {
          setRedirectTo(registerUrl);
          return;
        }

        setRedirectTo(loginUrl);
      } catch {
        if (!cancelled) {
          setRedirectTo(loginUrl);
        }
      }
    };

    resolveRedirect();

    return () => {
      cancelled = true;
    };
  }, [returnTo, invitationToken]);

  if (redirectTo === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rowing-blue"></div>
      </div>
    );
  }

  return <Navigate to={redirectTo} replace />;
};

export default InviteAuthRedirect;
